module.exports = __webpack_public_path__ + "media/images/flags/16/Fiji-a7748424183b0103325f90193383e46f.png";